import axios from 'axios';
import { OCTOPUS_BASE_URL } from './index';

export const getEventsFromTracking = (bookingID: string) => axios.get(`${OCTOPUS_BASE_URL}/inspector/${bookingID}`);
